import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
});

// News
export const getNews = () => api.get('/news');
export const getNewsItem = (id) => api.get(`/news/${id}`);

// Teams (Mannschaften)
export const getTeams = () => api.get('/teams');
export const getTeam = (id) => api.get(`/teams/${id}`);

// Players
export const getPlayers = () => api.get('/players');
export const getPlayer = (id) => api.get(`/players/${id}`);

// Tournaments
export const getTournaments = () => api.get('/tournaments');
export const getTournament = (id) => api.get(`/tournaments/${id}`);
export const registerForTournament = (id) => api.post(`/tournaments/${id}/register`);

// Training
export const getTrainingSessions = () => api.get('/training');
export const getTrainingSession = (id) => api.get(`/training/${id}`);
export const registerForTraining = (id) => api.post(`/training/${id}/register`);
export const cancelTrainingRegistration = (id) => api.delete(`/training/${id}/register`);

// Gallery
export const getGallery = () => api.get('/gallery');
export const getGalleryCategories = () => api.get('/gallery/categories');
export const getGalleryByCategory = (id) => api.get(`/gallery/category/${id}`);

// Sponsors
export const getSponsors = () => api.get('/sponsors');
export const submitSponsorInquiry = (data) => api.post('/sponsors/inquiry', data);

// Contact
export const submitContact = (data) => api.post('/contact', data);

// Schedule
export const getScheduleTeams = () => api.get('/schedule/teams');
export const getNextGame = () => api.get('/schedule/next');
export const getScheduleStatistics = () => api.get('/schedule/statistics');

// Notifications
export const getNotifications = () => api.get('/notifications');
export const markNotificationsSeen = () => api.post('/notifications/mark-seen');

// Attendance
export const getAttendance = (month, year) => {
  const params = {};
  if (month) params.month = month;
  if (year) params.year = year;
  return api.get('/attendance', { params });
};

// Admin APIs
export const adminGetMembers = () => api.get('/admin/members');
export const adminGetMember = (id) => api.get(`/admin/members/${id}`);
export const adminUpdateMember = (id, data) => api.put(`/admin/members/${id}`, data);
export const adminDeleteMember = (id) => api.delete(`/admin/members/${id}`);

export const adminCreateTeam = (data) => api.post('/admin/teams', data);
export const adminUpdateTeam = (id, data) => api.put(`/admin/teams/${id}`, data);
export const adminDeleteTeam = (id) => api.delete(`/admin/teams/${id}`);

export const adminCreatePlayer = (data) => api.post('/admin/players', data);
export const adminUpdatePlayer = (id, data) => api.put(`/admin/players/${id}`, data);
export const adminDeletePlayer = (id) => api.delete(`/admin/players/${id}`);

export const adminCreateTournament = (data) => api.post('/admin/tournaments', data);
export const adminUpdateTournament = (id, data) => api.put(`/admin/tournaments/${id}`, data);
export const adminDeleteTournament = (id) => api.delete(`/admin/tournaments/${id}`);
export const adminUploadTournamentImage = (tournamentId, formData) =>
  api.post(`/admin/tournaments/${tournamentId}/image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const adminCreateTraining = (data) => api.post('/admin/training', data);
export const adminUpdateTraining = (id, data) => api.put(`/admin/training/${id}`, data);
export const adminDeleteTraining = (id) => api.delete(`/admin/training/${id}`);

export const adminCreateNews = (data) => api.post('/admin/news', data);
export const adminUpdateNews = (id, data) => api.put(`/admin/news/${id}`, data);
export const adminDeleteNews = (id) => api.delete(`/admin/news/${id}`);
export const adminUploadNewsImage = (newsId, formData) =>
  api.post(`/admin/news/${newsId}/image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const adminCreateSponsor = (data) => api.post('/admin/sponsors', data);
export const adminUpdateSponsor = (id, data) => api.put(`/admin/sponsors/${id}`, data);
export const adminDeleteSponsor = (id) => api.delete(`/admin/sponsors/${id}`);

export const adminCreateGalleryItem = (data) => api.post('/admin/gallery', data);
export const adminDeleteGalleryItem = (id) => api.delete(`/admin/gallery/${id}`);
export const adminCreateGalleryCategory = (data) => api.post('/admin/gallery/categories', data);
export const adminDeleteGalleryCategory = (id) => api.delete(`/admin/gallery/categories/${id}`);

export const adminGetStats = () => api.get('/admin/stats');
export const adminGetMessages = () => api.get('/admin/messages');
export const adminMarkMessageRead = (id) => api.put(`/admin/messages/${id}/read`);
export const adminDeleteMessage = (id) => api.delete(`/admin/messages/${id}`);
export const adminGetSponsorInquiries = () => api.get('/admin/sponsor-inquiries');
export const adminDeleteSponsorInquiry = (id) => api.delete(`/admin/sponsor-inquiries/${id}`);
export const adminGetTrainingRegistrations = () => api.get('/admin/training-registrations');
export const adminGetTournamentRegistrations = () => api.get('/admin/tournament-registrations');
export const adminUploadSponsorLogo = (sponsorId, formData) =>
  api.post(`/admin/sponsors/${sponsorId}/logo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Attendance Admin
export const adminRecordAttendance = (data) => api.post('/admin/attendance/record', data);
export const adminDeleteAttendance = (id) => api.delete(`/admin/attendance/${id}`);
export const adminGetAttendanceRecords = (month, year) => {
  const params = {};
  if (month) params.month = month;
  if (year) params.year = year;
  return api.get('/admin/attendance/records', { params });
};
export const adminSetAttendanceReward = (data) => api.post('/admin/attendance/reward', data);

// Profile update
export const updateMyProfile = (data) => api.put('/auth/me', data);

// Admin: Password Reset
export const adminResetMemberPassword = (userId, password) =>
  api.put(`/admin/members/${userId}/reset-password`, { password });

export const uploadProfilePicture = (formData) =>
  api.post('/upload/profile-picture', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminUploadMemberPicture = (userId, formData) =>
  api.post(`/admin/members/${userId}/profile-picture`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminDeleteMemberPicture = (userId) =>
  api.delete(`/admin/members/${userId}/profile-picture`);
export const adminUploadPlayerPhoto = (playerId, formData) =>
  api.post(`/admin/players/${playerId}/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export default api;
